import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <div className="grid grid-cols-4 w-full sm:w-[calc(100%-135px)]">
                <div className="text-center"><div className="font-bold text-2xl">{days}</div><div>Днів</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{hours}</div><div>Годин</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{minutes}</div><div>Хвилин</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{seconds}</div><div>Секунд</div></div>
            </div>;
        }
    };

    return (
        <div className="sm:flex flex-wrap justify-center items-center mb-4">
            <div className="w-full sm:w-[120px] mr-[15px] text-center sm:text-right text-sm mb-4 sm:mb-0">
                Старт програми через
            </div>
            <Countdown
                date={Date.now() + (new Date('2025-09-04T09:30:00') - Date.now())}
                renderer={renderer}
            />
        </div>
    )
}

export default MyCountdown